module.exports = __webpack_public_path__ + "img/nurse.0857589d.svg";